/**
 * @deprecated Since version 2.0.0 - Use TanStack Query instead
 * 
 * This file contains legacy NgRx actions that are no longer maintained.
 * 
 * Migration Guide:
 * - For location list operations, use `WarehousesQueriesService.useWarehousesList()` or `UbicacionesQueriesService.useUbicacionesList()`
 * - For location tree operations, use `UbicacionesQueriesService.useUbicacionesTree()`
 * - For creating locations, use `WarehousesQueriesService.useCreateWarehouse()` or `UbicacionesQueriesService.useCreateUbicacion()`
 * - For updating locations, use `WarehousesQueriesService.useUpdateWarehouse()` or `UbicacionesQueriesService.useUpdateUbicacion()`
 * - For deleting locations, use `WarehousesQueriesService.useDeleteWarehouse()` or `UbicacionesQueriesService.useDeleteUbicacion()`
 * 
 * Example migration:
 * ```typescript
 * // OLD (NgRx):
 * this.store.dispatch(loadLocationRootList({ filters: { page: 1 } }));
 * this.locations$ = this.store.pipe(select(fromLocations.getLocationsList));
 * 
 * // NEW (TanStack Query):
 * filters = signal<LocationFilterModel>({ page: 1 });
 * locationsQuery = inject(WarehousesQueriesService).useWarehousesList(this.filters);
 * locations = computed(() => this.locationsQuery.data()?.results || []);
 * ```
 * 
 * See documentation: libs/kanzi-location/docs/FASE-1-RESUMEN.md
 */
import { createAction, props } from '@ngrx/store';
import { LocationModel, LocationFilterModel } from '@kanzi-apes/kanzi-models';

/**
 * @deprecated Use TanStack Query initialization instead
 */
export const initAuth = createAction('[Locations Page] Init');

/**
 * @deprecated Use WarehousesQueriesService.useWarehousesList() or UbicacionesQueriesService.useUbicacionesList()
 */
export const loadLocationRootList = createAction(
  '[Locations/API] Load Location Root List',
  props<{ filters: LocationFilterModel }>()
);

/**
 * @deprecated Use TanStack Query success state from query.data()
 */
export const loadLocationRootListSuccess = createAction(
  '[Locations/API] Load Location Root List Success',
  props<{ listItems: LocationModel[] }>()
);

/**
 * @deprecated Use TanStack Query error state from query.error()
 */
export const loadLocationRootListFailure = createAction(
  '[Locations/API] Load Location Root List Failure',
  props<{ error: any }>()
);

/**
 * @deprecated Use signal-based state management instead
 */
export const selectLocationRoot = createAction(
  '[Locations Page] Select Location Root',
  props<{ location: LocationModel | null }>()
);

/**
 * @deprecated Use Router.navigate() with route params instead
 */
export const locationIdSelected = createAction(
  '[Locations Page] Location Id Selected',
  props<{ locationId: number }>()
);
